"use client";

import { useVisitorData } from "@fingerprint/react";
import { useCallback } from "react";
import { FINGERPRINT_TIMEOUT_MS } from "../lib/fingerprint";

type IdentifyOptions = {
  /** Event tags. Client-set values are spoofable; never base decisions on them. */
  tags?: Record<string, string>;
};

/**
 * Returns a function that identifies the browser and resolves to the
 * Fingerprint event_id, or undefined. Ad blockers, CSP blocks, outages, and a
 * missing provider resolve to undefined: sign-in never fails because of
 * identification.
 */
export function useFingerprintEventId(): (
  options?: IdentifyOptions,
) => Promise<string | undefined> {
  const { getData } = useVisitorData({ immediate: false });

  return useCallback(
    async (options?: IdentifyOptions) => {
      try {
        const { event_id, visitor_id } = await getData({
          timeout: FINGERPRINT_TIMEOUT_MS,
          tags: options?.tags,
        });
        if (process.env.NODE_ENV !== "production") {
          console.info("[fingerprint]", { visitor_id, event_id });
        }
        return event_id;
      } catch (error) {
        console.warn("[fingerprint] identification failed", error);
        return undefined;
      }
    },
    [getData],
  );
}
